import { useEffect, useMemo, useState } from "react";
import { getDefaultPharmacist } from "../../utils/helper/helper";
import { useAuthSelector } from "../../services/selectors/authSelector";

import CreatableSelect from "react-select/creatable";

export const DeliveryConsultationDropdown = ({ consultation, setConsultation }) => {

    const { pharmacyId, driverDefaultPharmacist } = useAuthSelector()

    const [defaultPharmacist, setDefaultPharmacist] = useState(null)

    const [optionsList, setOptionsList] = useState([
        { label: 'Dose Changed', value: 'Dose Changed' },
        { label: 'Consult offered but refused by patient', value: 'Consult offered but refused by patient' },
        { label: 'In person ', value: 'In person' },
        { label: 'Call made', value: 'Call made' },
        { label: 'Written', value: 'Written' },
        { label: 'Patient Refused counselling', value: 'Patient Refused counselling' },
        { label: 'Consultation provided', value: 'Consultation provided' },
    ])

    const handleCreateOption = (inputValue) => {
        const newOption = { label: inputValue, value: inputValue };
        setConsultation(newOption)
        setOptionsList((prevOptions) => [...prevOptions, newOption]);
    }

    const handleSelect = (value) => {
        setConsultation(value)
    }

    useEffect(() => {
        const matchedPharmacies = getDefaultPharmacist(pharmacyId, driverDefaultPharmacist);
        setDefaultPharmacist(matchedPharmacies[0]?.driver_pharmacist_user?.type)
    }, [pharmacyId, driverDefaultPharmacist])

    // useEffect(() => {
    //     if (defaultPharmacist === 'pharmacist') {
    //         setConsultation({
    //             label: 'Consultation provided',
    //             value: 'Consultation provided'
    //         })
    //     }
    // }, [defaultPharmacist])

    return (
        <>
            {defaultPharmacist === 'pharmacist' &&
                <div className="bg-gray-100 rounded-md mb-3">
                    <CreatableSelect
                        onChange={handleSelect}
                        value={consultation}
                        options={optionsList}
                        placeholder="Select or add a consultation"
                        isSearchable
                        className="basic-multi-select"
                        classNamePrefix="react-select"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        onCreateOption={handleCreateOption}
                    />
                </div>
            }
        </>
    )
}

export const NewRxesConsultationDropdown = ({ type, rxData, setCounsellingValues, counsellingValues, disabled = false }) => {

    const [selectedValue, setSelectedValue] = useState(null);

    let optionsList;

    if (type === 'new_rx') {
        optionsList = [
            { label: 'Consultation provided', value: 'Consultation provided' },
            { label: 'Consult offered but refused by patient', value: 'Consult offered but refused by patient' },
            { label: 'Patient Refused counselling', value: 'Patient Refused counselling' }
        ];
    } else {
        optionsList = [
            { label: 'Call made', value: 'Call made' },
            { label: 'In person ', value: 'In person' },
            { label: 'Written', value: 'Written' },
        ];
    }

    // Set initial selected value on mount/update
    useEffect(() => {
        const entry = counsellingValues?.find(item => item.rxid === rxData?.id);
        setSelectedValue(entry?.dropdownValue || null);
    }, [rxData?.id, counsellingValues]);

    // Prevent duplicate rxid entries
    useEffect(() => {
        setCounsellingValues(prev => {
            const exists = prev?.some(entry => entry?.rxid === rxData?.id);
            if (!exists) {
                return [
                    ...prev,
                    {
                        rxid: rxData?.id,
                        dropdownValue: null
                        // type === 'pending_counselling_rxes' ? null : { // Change made here
                        //     label: '',
                        //     value: ''
                        // }
                    }
                ];
            }
            return prev;
        });
    }, [rxData?.id]); // depend only on id

    const handleSelect = (value) => {
        if (disabled) return;
        setSelectedValue(value); // update local
        setCounsellingValues(prev =>
            prev.map(entry =>
                entry.rxid === rxData.id
                    ? { ...entry, dropdownValue: value }
                    : entry
            )
        )
    }

    // Only show red border when not disabled and no value selected; when parent RX not checked, no red border
    const showErrorBorder = !disabled && !selectedValue;
    const customStyles = {
        control: (provided, state) => ({
            ...provided,
            borderColor: showErrorBorder ? 'red' : '#d1d5db',
            boxShadow: state.isFocused
                ? (showErrorBorder ? '0 0 0 1px red' : '0 0 0 1px #2684FF')
                : 'none',
            '&:hover': {
                borderColor: showErrorBorder ? 'red' : '#2684FF',
            },
        }),
    };

    return (
        <>
            <div className={`bg-gray-100 rounded-md mb-3 ${disabled ? 'opacity-60 pointer-events-none' : ''}`}>
                <CreatableSelect
                    onChange={handleSelect}
                    styles={customStyles}
                    value={counsellingValues?.find(entry => entry?.rxid === rxData.id)?.dropdownValue}
                    options={optionsList}
                    placeholder="Select or add a consultation"
                    className="basic-multi-select"
                    classNamePrefix="react-select"
                    menuPortalTarget={document.body}
                    menuPosition="fixed"
                    isDisabled={disabled}
                />
            </div>
        </>
    )
}
